import { FC } from 'react';
import { useDetailsBooking } from 'lib/hooks';
import { getUpdatePaymentMethodPageLink } from 'lib/links';
import { FailedScheduledPayment } from './FailedScheduledPayment';
import { SelfServiceAPI } from 'types';
import last from 'lodash/last';

const hasPaymentFailed = (payment: SelfServiceAPI.ScheduledPayment) => {
  return payment.attempts.every((attempt) => attempt.status === 'FAILED');
};

export const FailedScheduledPaymentContainer: FC = () => {
  const { booking } = useDetailsBooking();

  if (booking.state === 'CANCELLED') return null;

  if (booking.flags.isChangeInProgress) return null;

  if (booking.flags.isFinalising) return null;

  if (booking.paymentSchedule.length === 0) return null;

  const failedPayments = booking.paymentSchedule.filter(hasPaymentFailed);

  if (failedPayments.length === 0) return null;

  const payment = failedPayments[0];
  const attempt = last(payment.attempts);
  const allocation = attempt?.paymentAllocations?.[0] as SelfServiceAPI.ScheduledPaymentAllocation | undefined;
  const paymentMethod = allocation?.paymentMethod;

  if (!attempt?.attemptedAt || !paymentMethod) return null;

  return (
    <FailedScheduledPayment
      total={payment.total}
      paymentDueDate={payment.deferredTo}
      failedPaymentDate={attempt.attemptedAt}
      cardType={paymentMethod.cardType}
      lastFourDigits={paymentMethod.lastFourDigits}
      updatePaymentMethodUrl={getUpdatePaymentMethodPageLink(booking.id)}
    />
  );
};
